{
	"id": 7505,
	"moduleNumber": 5,
	"title": "The Professional Educator and the Community",
	"subtitle": "Model professional values by protecting confidentiality, using resources responsibly, and maintaining public trust.",
	"kgNodeId": "module-5",
	"moduleKind": "standard",
	"moduleKindLabel": "Lesson",
	"summary": "Module 5 is reserved for community-facing educator ethics, including family relationships, community expectations, assessment integrity, and responsible professional conduct outside the classroom.",
	"estimatedDurationMinutes": 35,
	"activityCount": 2,
	"knowledgeCheck": {
		"included": true,
		"questionCount": 5
	}
}
